import httpClientService from '@/services/httpClientService';

export default {
	getClients: () =>
		httpClientService.Get('/ClientsManagementModule/api/ClientsManagement'),
	getClientsById: (id) =>
		httpClientService.Get(
			'/ClientsManagementModule/api/ClientsManagement/' + id
		),
	getDbByName: (name) =>
		httpClientService.Get(
			'/ClientsManagementModule/api/DbConnections/GetByName?name=' + name
		),
	createClient: (newClient) =>
		httpClientService.PostMultiPart(
			'/ClientsManagementModule/api/ClientsManagement',
			newClient
		),
	updateClient: (item, id) =>
		httpClientService.PutMultiPart(
			`/ClientsManagementModule/api/ClientsManagement/${id}`,
			item
		),
	deleteClient: (id) =>
		httpClientService.Delete(
			'/ClientsManagementModule/api/ClientsManagement/' + id
		),
	getDbConnection: () =>
		httpClientService.Get('/ClientsManagementModule/api/DbConnections'),
	getDbConnectionbyId: (id) =>
		httpClientService.Get(
			'/ClientsManagementModule/api/DbConnections/' + id
		),
	createDbConnection: (newDbConnection) =>
		httpClientService.Post(
			'/ClientsManagementModule/api/DbConnections',
			newDbConnection
		),
	updateDbConnection: (item) =>
		httpClientService.Put(
			'/ClientsManagementModule/api/DbConnections',
			item
		),
	deleteDbConnection: (id) =>
		httpClientService.Delete(
			'/ClientsManagementModule/api/DbConnections/' + id
		),
	fileUpload: () =>
		httpClientService.Post(
			'/ClientsManagementModule/ClientsManagementModule/api/UploadFile2'
		),
	removeClientLogo: (clientId) =>
		httpClientService.Put(
			`/ClientsManagementModule/api/ClientsManagement/${clientId}/removeLogo`
		),
};
